<script lang="ts">
	import { Button, ButtonGroup, Container, Select, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let categories: string[];
	export let categoryOptionsI18n: string[];
	export let selectedCategory: string;
	export let changeCategory: (detail: string) => void;

	export let profileOptionsI18n: string[];
	export let profileOptions: string[];
	export let selectedProfile: string;
	export let changeProfile: (detail: string) => void;

	const onProfileChange = (e: CustomEvent<any>) => {
		changeProfile(String((e as any).detail));
	};
</script>

<Text styleType="h2" class="mb-s">
	{$format('label_category', { default: 'Category' })}
</Text>
<Container backgroundColor="color-base" class="mb-s" padding="xs">
	<ButtonGroup aria-label={$format('label_category', { default: 'Category' })}>
		{#each categories as category, i}
			<Button
				class={selectedCategory === category ? 'active' : ''}
				size="m"
				on:click={() => changeCategory(categoryOptionsI18n[i])}
			>
				{categoryOptionsI18n[i]}
			</Button>
		{/each}
	</ButtonGroup>
</Container>
<Text styleType="h2" class="mb-s">
	{$format('label_profile', { default: 'Profile' })}
</Text>
<Select
	a11yProps={{
		clearButtonAriaLabel: $format('label_profile', { default: 'Profile' }),
	}}
	id="select-m6quaei"
	class="mb-s"
	value={profileOptionsI18n[profileOptions.indexOf(selectedProfile)]}
	options={profileOptionsI18n}
	icon={null}
	on:change={onProfileChange}
	aria-label={$format('label_profile', { default: 'Profile' })}
/>
